import es from 'forms/i18n/es.json';
import en from 'forms/i18n/en.json';

const LOCALES = { es, en };
const SUPPORTED = Object.keys(LOCALES);

function detectLocale() {
  const params = new URLSearchParams(window.location.search);
  const lang = params.get('lang');
  if (lang && SUPPORTED.includes(lang)) return lang;
  // Check browser language as fallback
  const browserLang = (navigator.language || '').slice(0, 2).toLowerCase();
  return SUPPORTED.includes(browserLang) ? browserLang : 'es';
}

const locale = detectLocale();
const messages = LOCALES[locale] || es;

/**
 * Translate a key, replacing {placeholder} tokens with values from the params object.
 */
export function t(key, params = {}) {
  let msg = messages[key] ?? key;
  Object.entries(params).forEach(([k, v]) => {
    msg = msg.replace(`{${k}}`, v);
  });
  return msg;
}

export function useLocale() {
  return { t, locale };
}
